export default [
  {
    header: 'instagram.posting_service',
  },
  {
    title: 'instagram.post',
    icon: 'Edit3Icon',
    route: 'owner:insta-poster',
  },
  {
    title: 'instagram.published-post',
    icon: 'TrelloIcon',
    route: 'owner:insta-published-posts',
  },
  {
    title: 'instagram.scheduled-post',
    icon: 'ClockIcon',
    route: 'owner:insta-scheduled-posts',
  },
  /* {
    title: 'poster.watermark',
    route: 'maps-leaflet',
    icon: 'LayersIcon',
  }, */
]
